import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { del } from 'utils/http'

export const useCustomerUserRemove = () => {
  const customerId = useCustomerId()
  const queryClient = useQueryClient()

  const removeCustomerUser = ({ userId, roleId }: any) =>
    del(`/management/customers/${customerId}/users/${userId}`, { role_id: roleId })

  return useMutation({
    mutationFn: removeCustomerUser,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customer', customerId, 'users'] })
    },
  })
}
